import { View } from './view'

export const ViewTabs = View
